export default "__VITE_ASSET__15e2248d__"